module.exports = __webpack_public_path__ + "static/media/Step2.967dd6d4.svg";